<schedule-detail-header class="bq9-issue-header"
                        title="Issue Details"
                        [subtitle]="area.name"
                        [backCallback]="goBack.bind(this)"
                        [backLabel]="'Celebration'"
                        [showCloud]="true"
                        [isRefreshingInBackground]="isRefreshingInBackground()"></schedule-detail-header>
<div class="bq9-issue-details"
     data-testid="bq9-container-issue-details">
  <div class="bq9-container-issue-details-content"
       [appDataUpdatedFade]="dataUpdatedPulse()"
       data-testid="bq9-container-issue-details-content">
    <div class="original-issue-card">
      <div class="bq9-issue-text bq9-issue-text--bold">Original Issue</div>
      <div class="bq9-issue-text"
           data-testid="bq9-issue-text">
        {{ issue.text }}
      </div>
      <app-assertion-image-gallery [images]="issueTypeMedia"
                                   [readonly]="true"
                                   data-testid="bq9-issue-details-image-gallery">
      </app-assertion-image-gallery>
    </div>

    @if(issue.isConfirmedByHomeowner) {
      <div class="confirmed-complete-card">
        <div class="bq9-issue-text bq9-issue-text--bold">Completion Photos* (Max {{ maxPhotos }})</div>

        <app-photo-capture inputId="issue-details"
                           [images]="allImages()"
                           [disabled]="imageCompressionPipelineService.isCompressingImages()"
                           [loading]="imageCompressionPipelineService.isLoadingImages()"
                           [optimizing]="imageCompressionPipelineService.isCompressingImages()"
                           [processingCount]="imageCompressionPipelineService.numberOfImagesBeingProcessed()"
                           (filesSelected)="onPhotosSelected($event)"
                           (imageClicked)="openImagesModal($event)"
                           testId="bq9-issue-details-photo" />
      </div>
    }
  </div>

  @if (issue.isConfirmedByHomeowner) {
    <div class="bq9-issue-details-footer bq9-issue-resolved-footer"
         data-testid="bq9-issue-details-resolved-footer">
      <app-vertical-button-group [buttons]="resolvedFooterButtons"
                                 testId="bq9-issue-details-resolved-footer-buttons" />
    </div>
  }
</div>

@if (!isResolved) {
  <div class="bq9-issue-details-footer"
       data-testid="bq9-issue-details-footer">
    <div class="title-label">
      Is this item complete?
    </div>
    <app-vertical-button-group [buttons]="completeQuestionButtons"
                               testId="bq9-issue-details-question-buttons" />
  </div>
}

<app-complete-bottom-sheet [(isOpen)]="showDetailsBottomSheet"
                           [itemIdentifier]="issue.identifier"
                           (save)="savePhotoRequired($event)" />

<router-outlet />